import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

const StickyNavbar = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDesktop, setIsDesktop] = useState(false);

  // Check if we're on desktop - hide navbar on desktop, show on mobile/tablet
  useEffect(() => {
    const checkDesktop = () => {
      const width = window.innerWidth;
      
      // Simple desktop detection - anything >= 1024px is considered desktop
      // This means mobile phones and tablets (including iPad) will show the navbar
      const isDesktopEnvironment = width >= 1024;
      
      setIsDesktop(isDesktopEnvironment);
    };
    
    checkDesktop();
    window.addEventListener('resize', checkDesktop);
    return () => window.removeEventListener('resize', checkDesktop);
  }, []);

  // Detect when modals are open
  useEffect(() => {
    const checkForModals = () => {
      const modalSelectors = [
        '[role="dialog"]',
        '.modal-overlay',
        '.fixed.inset-0.bg-black',
        '.fixed.inset-0.bg-gray-600',
        '.ReactModal__Overlay',
        'div[class*="fixed"][class*="inset-0"][class*="bg-black"]',
        'div[class*="fixed"][class*="inset-0"][class*="bg-gray"]'
      ];
      
      const hasOpenModal = modalSelectors.some(selector => {
        const elements = document.querySelectorAll(selector);
        return Array.from(elements).some(el => {
          const style = window.getComputedStyle(el);
          return style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0';
        });
      });
      
      setIsModalOpen(hasOpenModal);
    };

    checkForModals();
    
    const observer = new MutationObserver(checkForModals);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style']
    });

    return () => observer.disconnect();
  }, []);

  // Hide navbar when modal is open or on desktop (>= 1024px)
  // Show navbar on mobile phones and tablets (< 1024px)  
  if (isModalOpen || isDesktop) return null;

  return (
    <motion.nav
      initial={{ y: -100, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.3 }}
      className="fixed top-0 left-0 right-0 z-50 bg-white/10 backdrop-filter backdrop-blur-lg border-b border-white/20 shadow-lg"
    >
      <div className="max-w-full mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-center h-16">
          {/* Logo */}
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 bg-gradient-to-br from-primary to-secondary rounded-xl flex items-center justify-center shadow-lg">
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="text-white"
              >
                <path d="M22 10v6M2 10l10-5 10 5-10 5z"/>
                <path d="M6 12v5c3 3 9 3 12 0v-5"/>
              </svg>
            </div>
            <div className="flex flex-col">
              <span className="text-white font-bold text-lg leading-tight">Somo Academia</span>
              <span className="text-white/60 text-xs leading-tight">Academic Excellence</span>
            </div>
          </div>
        </div>
      </div>
    </motion.nav>
  );
};

export default StickyNavbar;